module.exports = __webpack_public_path__ + "static/img/flowchart-cardio.b2b8ea6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flowchart-cardio.svg?data
// module id = 9vYh
// module chunks = 1